export const utcTimeZones = {
  filters: {
    utcFromNow(value) {
      return moment.utc(value).fromNow();
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/time.js